import React, { useEffect, useContext } from 'react';
import { detailsContext } from './context/DetailsProvider';
import { SVBTypography } from '@svb/svb-react-components';

const SolutionDetailsBenefits = ({ children, title}) => {
  const { addTitle, idGenerator } = useContext(detailsContext);

  useEffect(() => {
    addTitle(title);
  }, [title]);
  return (
    <section
      className="solutions_solutionDetails_benefits_wrapper"
      id={idGenerator(title)}
    >
      <SVBTypography type="heading-large" variant="mb-4">{title}</SVBTypography>
      <div className="solutions_solutionDetails_cards_wrapper row">{children}</div>
    </section>
  );
};
export default SolutionDetailsBenefits;